import React, { useEffect } from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import BudgetImpacts from '../../collection-templates/budget-impacts';

export const BudgetImpactFullWidget = (props) => {
  const queryClient = new QueryClient;

  useEffect(() => {
    const body = document.getElementsByTagName('body')[0];
    body.style.backgroundColor = "#0B0B0B";
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <BudgetImpacts
        widget={true}
        {...props} />
    </QueryClientProvider>
  );
};
